var exports = {
  "al": "issueTitle__v_3ZkZ",
  "zb": "issueTitleText__YssX6y",
  "Pp": "issueNumber__c0cJD_",
  "X2": "mutedText__ilK50g",
  "Zs": "firstButton__HHk5d5",
  "ak": "actionMenuButton__qwG9qD",
};

module.exports = exports;
